// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3EDG4","flashing":"Loader_flashing__90iu3","heading":"Loader_heading__259OO","blinking":"Loader_blinking__3w5dN"};